import { Grid, TextField } from '@material-ui/core';
import helpers from 'app/utils/helpers';
import React from 'react';

const PersonData = ({ personData }) => {
    return (
        <Grid container spacing={3}>
            <Grid item xs={12} sm={4}>
                <TextField
                    label="CPF"
                    value={helpers.formatarDocumento(personData.deCpf)}
                    variant="filled"
                    margin="dense"
                    disabled
                    fullWidth
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <TextField
                    name="nmCompleto"
                    label="Nome completo"
                    variant="filled"
                    margin="dense"
                    disabled
                    fullWidth
                    value={personData.nmCompleto}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <TextField
                    name="dtNascimento"
                    label="Data de nascimento"
                    variant="filled"
                    margin="dense"
                    disabled
                    fullWidth
                    value={helpers.formatarData(personData.dtNascimento)}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <TextField
                    name="deRg"
                    label="RG"
                    variant="filled"
                    margin="dense"
                    disabled
                    fullWidth
                    value={personData.deRg}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={3}>
                <TextField
                    name="dtRg"
                    label="Data de expedição"
                    variant="filled"
                    margin="dense"
                    disabled
                    fullWidth
                    value={helpers.formatarData(personData.dtRg)}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={3}>
                <TextField
                    name="sgOrgaoRg"
                    label="Órgão expedidor"
                    variant="filled"
                    margin="dense"
                    disabled
                    fullWidth
                    value={personData.sgOrgaoRg}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={2}>
                <TextField
                    name="sgUfRg"
                    label="UF"
                    variant="filled"
                    margin="dense"
                    disabled
                    fullWidth
                    value={personData.sgUfRg}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={3}>
                <TextField
                    name="deCnh"
                    label="CNH"
                    variant="filled"
                    margin="dense"
                    disabled
                    fullWidth
                    value={personData.deCnh}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={3}>
                <TextField
                    name="dtValidadeCnh"
                    label="Data de validade"
                    variant="filled"
                    margin="dense"
                    disabled
                    fullWidth
                    value={helpers.formatarData(personData.dtValidadeCnh)}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={3}>
                <TextField
                    name="tpCategoriaCnh"
                    label="Categoria CNH"
                    variant="filled"
                    margin="dense"
                    disabled
                    fullWidth
                    value={personData.tpCategoriaCnh}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={3}>
                <TextField
                    name="sgUfCnh"
                    label="UF"
                    variant="filled"
                    margin="dense"
                    disabled
                    fullWidth
                    value={personData.sgUfCnh}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <TextField
                    name="deFiliacaoPai"
                    label="Nome do Pai"
                    variant="filled"
                    margin="dense"
                    disabled
                    fullWidth
                    value={personData.deFiliacaoPai}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <TextField
                    name="deFiliacaoMae"
                    label="Nome da Mãe"
                    variant="filled"
                    margin="dense"
                    disabled
                    fullWidth
                    value={personData.deFiliacaoMae}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <TextField
                    name="nuInss"
                    label="Número de Registro no INSS"
                    variant="filled"
                    margin="dense"
                    disabled
                    fullWidth
                    value={personData.nuInss}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            </Grid>

            {personData.enderecoPessoa && (
                <>
                    <Grid item xs={12} sm={2}>
                        <TextField
                            variant="filled"
                            fullWidth
                            disabled
                            label="CEP"
                            name="cep"
                            value={
                                personData.enderecoPessoa?.deCep
                                    ? helpers.formatarCep(personData.enderecoPessoa?.deCep)
                                    : personData.deCep
                                      ? helpers.formatarCep(personData.deCep)
                                      : ''
                            }
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={2}>
                        <TextField
                            variant="filled"
                            fullWidth
                            disabled
                            label="UF"
                            name="uf"
                            value={
                                personData.enderecoPessoa?.municipio?.uf?.sgUf
                                    ? personData.enderecoPessoa?.municipio?.uf?.sgUf
                                    : personData.municipio?.uf?.sgUf
                                      ? personData.municipio?.uf?.sgUf
                                      : ''
                            }
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <TextField
                            variant="filled"
                            fullWidth
                            disabled
                            label="Município"
                            name="municipio"
                            value={
                                personData.enderecoPessoa?.municipio?.nmMunicipio
                                    ? personData.enderecoPessoa?.municipio?.nmMunicipio
                                    : personData.municipio?.nmMunicipio
                                      ? personData.municipio?.nmMunicipio
                                      : ''
                            }
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <TextField
                            variant="filled"
                            fullWidth
                            disabled
                            label="Bairro"
                            name="bairro"
                            value={
                                personData.enderecoPessoa?.deBairro
                                    ? personData.enderecoPessoa?.deBairro
                                    : personData.deBairro
                                      ? personData.deBairro
                                      : ''
                            }
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField
                            variant="filled"
                            fullWidth
                            disabled
                            label="Endereço"
                            name="endereco"
                            value={
                                personData.enderecoPessoa?.deEndereco
                                    ? personData.enderecoPessoa?.deEndereco
                                    : personData.deEndereco
                                      ? personData.deEndereco
                                      : ''
                            }
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={2}>
                        <TextField
                            variant="filled"
                            fullWidth
                            disabled
                            label="Número"
                            name="numero"
                            value={
                                personData.enderecoPessoa?.deNumeroEndereco
                                    ? personData.enderecoPessoa?.deNumeroEndereco
                                    : personData.deNumeroEndereco
                                      ? personData.deNumeroEndereco
                                      : ''
                            }
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <TextField
                            variant="filled"
                            fullWidth
                            disabled
                            label="Complemento"
                            name="complemento"
                            value={
                                personData.enderecoPessoa?.deComplemento
                                    ? personData.enderecoPessoa?.deComplemento
                                    : personData.deComplemento
                                      ? personData.deComplemento
                                      : ''
                            }
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </Grid>
                </>
            )}

            <Grid item xs={12} sm={6}>
                <TextField
                    variant="filled"
                    fullWidth
                    disabled
                    label="E-mail"
                    name="email"
                    value={personData.deEmail}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <TextField
                    variant="filled"
                    fullWidth
                    disabled
                    label="Telefone"
                    name="telefone"
                    value={personData.deTelefone ? helpers.formatarTelefone(personData.deTelefone) : ''}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            </Grid>

            <Grid item xs={12}>
                <TextField
                    variant="filled"
                    fullWidth
                    minRows={4}
                    disabled
                    label="Observações"
                    name="observacoes"
                    value={personData.deObservacao}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            </Grid>
        </Grid>
    );
};

export default PersonData;
